import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

import { TwcI18nModule } from '@topcon/twc-angular';

import { MagnetService } from '@mirage-projects/cw-commons';

import { AppEmbedComponent } from './app-embed.component';
import { AppRoutingModule } from './app-routing.module';
import { cookieConsentConfig } from './services/cookie-consent/cookie-consent-configuration';
import { CustomLoader } from './services/translate/custom-loader';
import { SharedModule } from './shared.module';

@NgModule({
    declarations: [AppEmbedComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        NgcCookieConsentModule.forRoot(cookieConsentConfig),
        TwcI18nModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomLoader,
                deps: [HttpClient, MagnetService],
            },
        }),
    ],
    bootstrap: [AppEmbedComponent],
})
export class AppEmbedModule {}
